import { AlertCircle, Check, X } from 'lucide-react';
import { Button } from '../ui/Button';

/** The client has its answer: its callback may be an app link, which leaves the browser here. */
export function ConsentHandedBack({ outcome }: { outcome: 'approve' | 'deny' }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-sm border border-neutral-200 p-6 text-center">
        <div className="mx-auto h-12 w-12 rounded-lg bg-[#0066FF] flex items-center justify-center">
          {outcome === 'approve' ? <Check className="h-6 w-6 text-white" /> : <X className="h-6 w-6 text-white" />}
        </div>
        <h1 className="mt-4 text-lg font-semibold text-neutral-900">
          {outcome === 'approve' ? 'Accès autorisé' : 'Accès refusé'}
        </h1>
        <p className="mt-2 text-sm text-neutral-600">
          Vous pouvez revenir dans l&apos;application qui a demandé l&apos;accès et fermer cet onglet.
        </p>
      </div>
    </div>
  );
}

/** The request could not be read: the server's own words, and the way back. */
export function ConsentError({ message, onBack }: { message: string; onBack: () => void }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
        <div className="flex items-center">
          <AlertCircle className="h-6 w-6 text-red-500 mr-3" />
          <h1 className="text-lg font-semibold text-neutral-900">Erreur</h1>
        </div>
        <p className="mt-3 text-sm text-neutral-700">{message}</p>
        <Button className="mt-6" variant="secondary" fullWidth onClick={onBack}>
          Retour à l&apos;administration
        </Button>
      </div>
    </div>
  );
}
